import {
  Grid,
  IconButton,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { ArrowDownward } from "@material-ui/icons";
import PeopleIcon from "@material-ui/icons/People";
import { CHECK_TOUR, VALIDATE_PAYMENT_TREATMENT } from "app/appConfig";
import ButtonComponent from "app/common/Component/Button/ButtonComponent";
import CommonButton from "app/common/Component/Button/CommonButton";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import Popup from "app/common/Component/Popup/Popup";
import TableComponent from "app/common/Component/Table/TableComponent";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import IconDelete from "app/common/Icon/IconDelete";
import { SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME } from "app/common/LocalConst";
import {
  formatMoney,
  getDateTime,
  getDefaultRoom,
  getDepartmentsUser,
  getPositionCodesTreatment,
  isAdmin,
} from "app/common/LocalFunction";
import { renderOptionsStaff } from "app/PatientManagement/ReportSalesAllocation/ReportSalesAllocationSearch";
import { pagingDepartment } from "app/services/DepartmentService";
import { pagingHealthCareRoom } from "app/services/HealthCareRoomService";
import { pagingPosition } from "app/services/PositionService";
import { pagingStaff } from "app/services/StaffService";
import { useStore } from "app/stores";
import { FieldArray, getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { forwardRef, memo, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const UncompletedServiceList = ({ readOnly }) => {
  const { t } = useTranslation();

  const {
    handleChangeFormSearchService,
    pageRegisterService,
    searchRegisterService,
  } = useStore().patientManagementStore.uncompletedRegisterServiceStore;

  let POSITION_CODES_TREATMENT = getPositionCodesTreatment();

  const columns = [
    {
      field: "service.name",
      title: t("Dịch vụ"),
      render: (row) => {
        const totalVolumnPerSv = row?.totalTreatmentTimes;
        const usedVolumnPerSv = row?.totalPerformedTimes;

        let percent =
          (+row?.totalPerformedTimes * 100) / +row?.totalTreatmentTimes || 0;
        // console.log("percent", percent);
        return (
          <div className="pl-1 pr-1">
            <div
            // onClick={() => handleOpenCreateOrEditServicePopup(row)}
            >
              <span className="service-code">{row?.service?.code}</span>{" "}
              <span className="service-name">
                {row?.service?.tradeName || row?.service?.name}
              </span>
            </div>
            <div class="fancy-progress-wrapper mt-1">
              <div class="fancy-progress-text">
                {row?.service?.serviceTreatmentType ===
                  SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME ? (
                  <div>
                    <b>{usedVolumnPerSv || 0}</b>
                    <>
                      <span className="mx-1">|</span>
                      <b style={{ color: "red" }}>{totalVolumnPerSv || 0}</b>
                    </>
                  </div>
                ) : (
                  <div>
                    <b>{row?.totalPerformedTimes || 0}</b>
                    {!row?.unLimited && (
                      <>
                        <span className="mx-1">|</span>
                        <b style={{ color: "red" }}>
                          {row?.totalTreatmentTimes || 0}
                        </b>
                      </>
                    )}
                  </div>
                )}
                {row?.unLimited && (
                  <>
                    <span className="mx-1">|</span>
                    <Tooltip title="Không giới hạn">
                      <span className="unlimited-badge">♾️</span>
                    </Tooltip>
                  </>
                )}
              </div>
              <div class="fancy-progress-bar">
                <div
                  class="fancy-progress-fill"
                  style={{ width: `${percent}%` }}
                ></div>
              </div>
            </div>
            <div className="flex mt-2">
              <Tooltip title="Đã thu" arrow>
                <div>
                  <b style={{ color: "green" }}>
                    {formatMoney(row?.totalBillPatientPaid || 0)}
                  </b>
                </div>
              </Tooltip>

              <span className="mx-2 text-gray-400">|</span>

              <Tooltip title="Cần thu" arrow>
                <div>
                  <b style={{ color: "red" }}>
                    {formatMoney(row?.amountActuallyPaid)}
                  </b>
                </div>
              </Tooltip>
            </div>
          </div>
        );
      },
    },
    {
      field: "remainingTreatmentTimes",
      title: t("SL sau đổi"),
      //render: (val) => val?.remainingTreatmentTimes,
    },
    ...(VALIDATE_PAYMENT_TREATMENT
      ? [
        {
          field: "remainingTreatmentTimes",
          title: t("Số buổi tối đa được chỉ định"),
          align: "center",
          render: (val) => {
            if (val?.unLimited) return "Không giới hạn";
            if (val?.amountActuallyPaid === 0)
              return val?.totalTreatmentTimes;
            const moneyToCollect =
              +val?.totalBillPatientPaid + (+val?.oldCredit || 0);
            const moneyToPay =
              +val?.amountActuallyPaid + (+val?.oldCredit || 0);
            let maxAssignTreatmentTimes;
            if (
              val?.service?.serviceTreatmentType ===
              SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME
            ) {
              maxAssignTreatmentTimes =
                (moneyToCollect / moneyToPay) * val?.totalTreatmentTimes -
                val?.totalPerformedTimes;
            } else {
              maxAssignTreatmentTimes = Math.floor(
                (moneyToCollect / moneyToPay) * val?.totalTreatmentTimes || 0
              );
            }

            return maxAssignTreatmentTimes;
          },
        },
      ]
      : []),
    {
      field: "orderDate",
      title: t("Khấu trừ"),
      render: (val) => formatMoney(val?.oldCredit),
    },

    {
      field: "orderDate",
      title: t("Ngày đăng ký"),
      render: (val) => getDateTime(val?.orderDate),
    },
    {
      field: "note",
      title: t("Ghi chú"),
    },
  ];

  const [indexDelete, setIndexDelete] = useState(null);

  const { setFieldValue, values } = useFormikContext();

  function handleChangeAndSetDepartment(valueArray) {
    //console.log("valueArray", valueArray);

    let formatData =
      valueArray?.length &&
      valueArray?.map((el) => {
        const roomDefault = getDefaultRoom(values?.department, el?.service);
        const encounterParticipants = el?.service?.roles?.map((el) => ({
          position: el?.position,
        }));
        let currentVolumeTreated =
          el?.service?.serviceTreatmentType ===
            SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME
            ? el?.totalTreatmentTimes - el?.totalPerformedTimes
            : null;
        return {
          ...el,
          note: "",
          department: values?.department,
          room: roomDefault?.room,
          encounterParticipants,
          currentVolumeTreated,
          // Mặc định: không làm ngoài cơ sở
          isOutsideDepartment: el?.isOutsideDepartment ?? false,
        };
      });
    // console.log("formatData", formatData);
    setFieldValue("uncompletedRegisterServices", formatData);
  }
  const isAdmins = isAdmin();
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={4}>
        <Grid>
          <Grid item xs={12}>
            <strong>Dịch vụ chưa hoàn thành</strong>
          </Grid>

          <Grid item xs={12}>
            <TableComponent
              // showOrdinalNumbers
              titleNodata={t("noData")}
              data={pageRegisterService?.content}
              minWidth={"120px"}
              initStateRow={searchRegisterService?.uncompletedRegisterServices}
              selectType={readOnly ? "none" : "multi"}
              handleChangeSelectedRows={handleChangeAndSetDepartment}
              columns={columns}
              dataPagination={{
                pageIndex: searchRegisterService?.pageIndex,
                pageSize: searchRegisterService?.pageSize,
                totalElements: pageRegisterService?.totalElements,
                totalPages: pageRegisterService?.totalPages,
                setPageIndex: (pageIndex) =>
                  handleChangeFormSearchService({ pageIndex }),
                setPageSize: (pageSize) =>
                  handleChangeFormSearchService({ pageSize }),
              }}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sm={8}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <strong>Dịch vụ đã chọn</strong>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={2} className="justify-right">
              <Grid item xs={12} sm={6} md={4}>
                <GlobitsPagingAutocomplete
                  name={"department"}
                  label={"Cơ sở"}
                  api={pagingDepartment}
                  disabled={!isAdmins || readOnly}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <GlobitsDateTimePicker
                  label="Thời gian chỉ định"
                  name="orderDate"
                  isDateTimePicker
                  requiredLabel
                  disabled={readOnly}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <GlobitsPagingAutocomplete
                  api={pagingStaff}
                  name="assigner"
                  requiredLabel
                  displayLabel="staffName"
                  label="Người chỉ định"
                  searchObject={{ isActive: true }}
                  ListboxComponent={forwardRef((props, ref) => {
                    const { children, ...other } = props;
                    return (
                      <ul {...other} ref={ref}>
                        <ol>
                          <li>{children}</li>
                        </ol>
                      </ul>
                    );
                  })}
                  renderOption={(option) => renderOptionsStaff(option)}
                  disabled={readOnly}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <FieldArray name="uncompletedRegisterServices">
              {({ push, remove, form }) => (
                <Grid xs={12}>
                  <div className="table-root">
                    <div style={{ width: "100%" }}>
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th width="5%">STT</th>
                            <th width="5%">Thao tác</th>

                            <th width="17%">Dịch vụ</th>
                            <th width="10%">Ngày đăng ký </th>
                            <th width="17%">Cơ sở </th>
                            <th width="10%">
                              {/* <RequiredLabel label={"Phòng"} requiredLabel /> */}
                              Phòng
                            </th>
                            <th width="17%">Số lượng điều trị </th>

                            <th width="20%">Ghi chú</th>
                            <th width="10%">Làm ngoài cơ sở</th>
                          </tr>
                        </thead>

                        <tbody>
                          {Array.isArray(values?.uncompletedRegisterServices) &&
                            Array.from(
                              values?.uncompletedRegisterServices
                            )?.map((row, index) => (
                              <UncompletedServiceRow
                                index={index}
                                nameSpace="uncompletedRegisterServices"
                                handleDeleteRow={() => setIndexDelete(index)}
                                row={row}
                                POSITION_CODES_TREATMENT={
                                  POSITION_CODES_TREATMENT
                                }
                              />
                            ))}

                          {(!values?.uncompletedRegisterServices ||
                            values?.uncompletedRegisterServices?.length ==
                            0) && (
                              <tr>
                                <td align="center" colSpan={7}>
                                  Chưa có dữ liệu
                                </td>
                              </tr>
                            )}
                        </tbody>
                      </table>

                      <ConfirmPopup
                        open={indexDelete !== null}
                        text="Hủy lựa chọn dịch vụ này?"
                        onClose={() => setIndexDelete(null)}
                        onConfirm={() => {
                          remove(indexDelete);
                          setIndexDelete(null);
                        }}
                        isNotAPromise
                      />
                    </div>
                  </div>
                </Grid>
              )}
            </FieldArray>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default memo(observer(UncompletedServiceList));

const UncompletedServiceRow = ({
  index,
  nameSpace,
  handleDeleteRow,
  row,
  POSITION_CODES_TREATMENT,
}) => {
  const withNameSpace = (field) =>
    nameSpace ? `${nameSpace}[${index}].${field}` : field;
  const { setFieldValue, values } = useFormikContext();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  const [openTourDetailPopup, setOpenTourDetailPopup] = useState(false);
  const isAdmins = isAdmin();
  const departmentsUser = getDepartmentsUser();
  const totalVolumnPerSv = row?.totalTreatmentTimes;
  const usedVolumnPerSv = row?.totalPerformedTimes;

  return (
    <>
      <tr>
        <td align="center">{index + 1}</td>
        <td>
          <div className="flex flex-center align-center">
            {isMobile && (
              <Tooltip title="Xem thông tin phân Tour ">
                <IconButton
                  size="small"
                  onClick={() => setOpenTourDetailPopup(true)}
                >
                  <PeopleIcon style={{ color: "#0270e3" }} />
                </IconButton>
              </Tooltip>
            )}

            <Tooltip title="Xóa">
              <IconButton
                size="small"
                onClick={() => handleDeleteRow({ id: row.id, index })}
              >
                <IconDelete />
              </IconButton>
            </Tooltip>
          </div>
        </td>
        <td>
          <div className="pl-1 pr-1 ">
            <div>
              <span className="service-code">{row?.service?.code}</span>{" "}
              <span className="service-name">
                {row?.service?.tradeName || row?.service?.name}
              </span>
            </div>
            {row?.service?.serviceTreatmentType ===
              SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME ? (
              <>
                <div className="font-size-12">
                  {`Số ${row?.service?.soldUnit || "Cc"} đã dùng: ${usedVolumnPerSv || 0
                    } / ${totalVolumnPerSv || 0}`}
                </div>
                <div className="font-size-12">
                  {`Số ${row?.service?.soldUnit || "Cc"} còn lại: ${totalVolumnPerSv - usedVolumnPerSv || 0
                    } `}
                </div>
              </>
            ) : (
              <span className="font-size-12">
                {`Lần điều trị: ${(row?.totalPerformedTimes || 0) +
                  (row?.waitingExecutionCount || 0) +
                  1
                  } ${row?.unLimited
                    ? "(Không giới hạn)"
                    : "| " + (row?.totalTreatmentTimes || 0)
                  }`}
              </span>
            )}
          </div>
        </td>

        <td>{getDateTime(row?.orderDate)}</td>

        <td>
          <GlobitsPagingAutocomplete
            name={withNameSpace("department")}
            api={
              isAdmins
                ? pagingDepartment
                : async () => ({
                  data: {
                    content: departmentsUser || [],
                    totalElements: departmentsUser?.length || 0,
                    totalPages: 1,
                  },
                })
            }
            onChange={(_, value) => {
              setFieldValue(withNameSpace("department"), value);
              const roomDefault = getDefaultRoom(value, row?.service);
              setFieldValue(withNameSpace("room"), roomDefault?.room);
            }}
            disabled
          />
        </td>

        <td>
          <GlobitsPagingAutocomplete
            name={withNameSpace("room")}
            api={pagingHealthCareRoom}
            disabled={
              getIn(values, withNameSpace("department"))?.id ? false : true
            }
            searchObject={{
              departmentId: getIn(values, withNameSpace("department"))?.id,
            }}
            onChange={(_, value) => {
              setFieldValue(withNameSpace("room"), value);
              setFieldValue(withNameSpace("department"), value?.department);
            }}
          />
        </td>
        <td>
          <GlobitsNumberInput
            roundNumberToFixed={2}
            decimal
            name={withNameSpace("currentVolumeTreated")}
            disabled={
              row?.service?.serviceTreatmentType !==
              SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME
            }
          />
        </td>

        <td>
          <GlobitsTextField
            name={withNameSpace("note")}
            // label="Ghi chú"
            notDelay
            isTextArea
            rows={2}
            placeholder="Ghi chú"
          />
        </td>

        {/* Làm ngoài cơ sở */}
        <td align="center">
          <input
            type="checkbox"
            checked={
              !!getIn(values, withNameSpace("isOutsideDepartment"))
            }
            onChange={(e) =>
              setFieldValue(
                withNameSpace("isOutsideDepartment"),
                e.target.checked
              )
            }
          />
        </td>
      </tr>

      {isMobile && openTourDetailPopup && (
        <Popup
          open
          handleClose={() => {
            setOpenTourDetailPopup(false);
          }}
          title="Chia tour"
          action={
            <>
              <ButtonComponent onClick={() => setOpenTourDetailPopup(false)}>
                Đóng
              </ButtonComponent>
            </>
          }
        >
          <div className="w-100 ">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <PatientServiceRegisterBriefInfo patientServiceRegister={row} />
              </Grid>
              <Grid item xs={12}>
                <EncounterParticipantsTable
                  POSITION_CODES_TREATMENT={POSITION_CODES_TREATMENT}
                  index={index}
                />
              </Grid>
            </Grid>
          </div>
        </Popup>
      )}

      {!isMobile && CHECK_TOUR && (
        <tr>
          <td colSpan={7}>
            <EncounterParticipantsTable
              POSITION_CODES_TREATMENT={POSITION_CODES_TREATMENT}
              index={index}
            />
          </td>
          {/* <td></td> */}
        </tr>
      )}
    </>
  );
};

const PatientServiceRegisterBriefInfo = observer(function (props) {
  const { patientServiceRegister } = props;

  const { values, setFieldValue } = useFormikContext();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <div
      className="px-2"
      style={{
        border: "1px dash #ccc ",
      }}
    >
      <Grid
        container
        spacing={1}
        className={`flex align-center ${isMobile && "flex-center"} mb-1 pl-4`}
        style={{
          border: "1px dashed #ccc",
          borderRadius: "4px",
        }}
      >
        <Grid item xs={12}>
          <Grid container spacing={1} className="flex-between service-info-box">
            <Grid item xs={12}>
              <span className="info-item info-service w-100 text-center">
                🧪 <strong>Dịch vụ:</strong>
                {patientServiceRegister?.service?.tradeName ||
                  patientServiceRegister?.service?.name}{" "}
                ({patientServiceRegister?.service?.code})
              </span>
            </Grid>

            <Grid item xs={12}>
              <span className="info-item info-service w-100 text-center">
                🧾 <strong>Lần điều trị:</strong>
                <span
                // className="font-size-12"
                >
                  {`${(patientServiceRegister?.totalPerformedTimes || 0) +
                    (patientServiceRegister?.waitingExecutionCount || 0) +
                    1
                    } ${patientServiceRegister?.unLimited
                      ? "(Không giới hạn)"
                      : "| " +
                      (patientServiceRegister?.totalTreatmentTimes || 0)
                    }`}
                </span>
              </span>
            </Grid>
            <Grid item xs={12}>
              <span className="info-item info-service w-100 text-center">
                🗓️ <strong>Ngày đăng ký:</strong>
                <span
                // className="font-size-12"
                >
                  {getDateTime(patientServiceRegister?.orderDate)}
                </span>
              </span>
            </Grid>

            <Grid item xs={12}>
              <span className="info-item info-service w-100 text-center">
                🏥 <strong>Cơ sở:</strong>
                {patientServiceRegister?.department?.name} (
                {patientServiceRegister?.department?.code})
              </span>
            </Grid>

            <Grid item xs={12}>
              <span className="info-item info-room">
                🏢 <strong>Phòng chỉ định:</strong>{" "}
                {patientServiceRegister?.room?.code} -{" "}
                {patientServiceRegister?.room?.name}
              </span>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
});

const EncounterParticipantsTable = observer(
  ({ POSITION_CODES_TREATMENT, index }) => {
    const { values, setFieldValue } = useFormikContext();

    return (
      <>
        <FieldArray
          name={`uncompletedRegisterServices[${index}].encounterParticipants`}
        >
          {({ remove, push }) => {
            let encounterParticipantsItems = getIn(
              values,
              `uncompletedRegisterServices[${index}].encounterParticipants`
            );
            let encounterParticipantsSpace = `uncompletedRegisterServices[${index}]`;

            return (
              <>
                <Grid item xs={12}>
                  <Grid container spacing={1} className="align-end">
                    <Grid item xs={12} sm={6} md={2}>
                      <p className="table-section-title">Chia tour</p>
                    </Grid>

                    <Grid item xs={6} sm={6} md={4}>
                      <GlobitsPagingAutocomplete
                        label={"Chọn vai trò"}
                        name={`${encounterParticipantsSpace}.position`}
                        api={pagingPosition}
                        searchObject={{
                          isUsing: true,
                          positionCodes: POSITION_CODES_TREATMENT,
                        }}
                        onChange={(_, value) => {
                          setFieldValue(
                            `${encounterParticipantsSpace}.position`,
                            value
                          );
                        }}
                      />
                    </Grid>

                    <Grid item xs={6} sm={6} md={4}>
                      <GlobitsPagingAutocomplete
                        label={"Nhân viên"}
                        displayLabel={"staffName"}
                        api={pagingStaff}
                        searchObject={{
                          positionId: getIn(values, "position")?.id || "",
                        }}
                        name={`${encounterParticipantsSpace}.staff`}
                        getOptionDisabled={(option) => {
                          const staffList = getIn(
                            values,
                            `uncompletedRegisterServices[${index}].encounterParticipants`
                          );
                          if (
                            staffList?.find(
                              (it) => it?.staff?.id === option?.id
                            )
                          ) {
                            return true;
                          }
                          return false;
                        }}
                        onChange={(_, value) => {
                          setFieldValue(
                            `${encounterParticipantsSpace}.staff`,
                            value
                          );
                          if (value?.position) {
                            setFieldValue(
                              `${encounterParticipantsSpace}.position`,
                              value.position
                            );
                          }
                        }}
                        ListboxComponent={forwardRef((props, ref) => {
                          const { children, ...other } = props;
                          return (
                            <ul {...other} ref={ref}>
                              <ol>
                                <li>{children}</li>
                              </ol>
                            </ul>
                          );
                        })}
                        renderOption={(option) => renderOptionsStaff(option)}
                      />
                    </Grid>

                    <Grid item xs={2} className="flex align-end">
                      <CommonButton
                        onClick={() => {
                          const staffList =
                            getIn(
                              values,
                              `uncompletedRegisterServices[${index}].encounterParticipants`,
                            ) || [];
                          const staffToAdd = getIn(
                            values,
                            `${encounterParticipantsSpace}.staff`,
                          );
                          if (
                            staffToAdd?.id &&
                            staffList.some((it) => it?.staff?.id === staffToAdd.id)
                          ) {
                            toast.warning(
                              "Nhân viên này đã được thêm vào danh sách",
                            );
                            return;
                          }
                          push({
                            staff: staffToAdd,
                            position: getIn(
                              values,
                              `${encounterParticipantsSpace}.position`,
                            ),
                          });
                          setFieldValue(
                            `${encounterParticipantsSpace}.position`,
                            null
                          );

                          setFieldValue(
                            `${encounterParticipantsSpace}.staff`,
                            null
                          );
                        }}
                      >
                        <ArrowDownward />
                      </CommonButton>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <div className="table-root mt-2">
                    <div>
                      <table className="table-container">
                        <colgroup>
                          <col style={{ minWidth: "18px", width: "5%" }} />
                          <col style={{ minWidth: "22px", width: "10%" }} />
                          <col style={{ minWidth: "160px", width: "32%" }} />
                          <col style={{ minWidth: "200px", width: "32%" }} />
                        </colgroup>

                        <thead>
                          <tr className="row-table-header">
                            <th width="5%">STT</th>
                            <th width="10%">Thao tác</th>
                            <th width="32%">Vai trò</th>
                            <th width="30%">Nhân viên</th>
                          </tr>
                        </thead>

                        <tbody>
                          {Array.isArray(encounterParticipantsItems) &&
                            encounterParticipantsItems.length > 0 ? (
                            encounterParticipantsItems?.map((parti, ind) => {
                              let nameSpaceParticipants = `uncompletedRegisterServices[${index}].encounterParticipants[${ind}]`;
                              return (
                                <tr
                                  key={ind}
                                  className={`${parti?.id ? "old-staff" : ""}`}
                                >
                                  <td align="center">{ind + 1}</td>
                                  <td align="center">
                                    <span
                                      tooltip={"Xóa"}
                                      className="pointer tooltip"
                                      onClick={() => remove(index)}
                                    >
                                      <IconDelete />
                                    </span>
                                  </td>
                                  <td>
                                    <GlobitsPagingAutocomplete
                                      api={pagingPosition}
                                      name={`${nameSpaceParticipants}.position`}
                                      autoUpercase
                                      searchObject={{
                                        isUsing: true,
                                        positionCodes: POSITION_CODES_TREATMENT,
                                      }}
                                      handleChange={function (_, value) {
                                        setFieldValue(
                                          `${nameSpaceParticipants}.position`,
                                          value
                                        );
                                        setFieldValue(
                                          `${nameSpaceParticipants}.staff`,
                                          null
                                        );
                                      }}
                                    />
                                  </td>
                                  <td>
                                    <GlobitsPagingAutocomplete
                                      api={pagingStaff}
                                      name={`${nameSpaceParticipants}.staff`}
                                      displayLabel={"staffName"}
                                      autoUpercase
                                      searchObject={{
                                        positionId:
                                          getIn(
                                            values,
                                            `${nameSpaceParticipants}.position.id`
                                          ) || "",
                                      }}
                                    />
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={4} align="center">
                                Chưa có dữ liệu
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Grid>
              </>
            );
          }}
        </FieldArray>
      </>
    );
  }
);

const ThermometerBar = ({ used, total }) => {
  const percent = Math.min((used / total) * 100, 100);

  return (
    <Tooltip title={`Đã dùng ${used}/${total}`} arrow>
      <div
        className="thermo"
        style={{
          "--value": used,
          "--total": total,
          "--percent": `${percent}%`,
        }}
      >
        <div className="thermo-total">{total}</div>

        <div className="thermo-body">
          <div className="thermo-head-oval"></div>
          <div className="thermo-scale"></div>

          <div className="thermo-mercury">
            <span className="thermo-current">{used}</span>
          </div>
        </div>
      </div>
    </Tooltip>
  );
};
